"use client";

import React from "react";
import { Home, HardHat, Fence, Palette, Layers, Building, Wrench, Hammer } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicesData = [{
  title: "Concrete",
  description: "Professional concrete foundations and structural work.",
  icon: HardHat,
  codeSnippet: `PSI_RATING = 4000\nREBAR_REINFORCED = TRUE\nCURING_PROTOCOL = "OPTIMAL"\n`
}, {
  title: "Fencing",
  description: "Secure and aesthetic fencing solutions for all properties.",
  icon: Fence,
  codeSnippet: `PERIMETER_SECURE = TRUE\nPOST_DEPTH = "STANDARD"\nMATERIAL_GRADE = "INDUSTRIAL"\n`
}, {
  title: "Painting",
  description: "Expert interior and exterior painting with premium finishes.",
  icon: Palette,
  codeSnippet: `COAT_LAYERS = 2\nFINISH_TYPE = "SATIN"\nSURFACE_PREP = "COMPLETE"\n`
}, {
  title: "Epoxy",
  description: "High-performance epoxy flooring for industrial and residential use.",
  icon: Layers,
  codeSnippet: `RESIN_BOND = "MAX"\nGLOSS_LEVEL = "HIGH"\nCHEMICAL_RESIST = TRUE\n`
}, {
  title: "Renovations",
  description: "Transformative remodeling and renovation expertise.",
  icon: Wrench,
  codeSnippet: `SPACE_OPTIMIZE = TRUE\nMODERN_UPGRADE = TRUE\nCRAFTSMANSHIP = "ELITE"\n`
}, {
  title: "Doors and Windows",
  description: "",
  icon: Home,
  codeSnippet: ""
}];
export default function OurTechnologicalEcosystem() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223966" id="our-expertise" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32 dark">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ff000008_1px,transparent_1px),linear-gradient(to_bottom,#ff000008_1px,transparent_1px)] bg-[size:32px_32px] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_50%,#000_70%,transparent_100%)]"></div>

      <style>
        {`
          @keyframes scrollCode {
            0% { transform: translateY(0); }
            100% { transform: translateY(-50%); }
          }
          .animate-scroll-code {
            animation: scrollCode 15s linear infinite;
          }
        `}
      </style>

      <div ref={ref} className={`container relative z-10 mx-auto px-4 transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <div className="mb-16 text-center">
          <h2 className="font-default mb-4 text-3xl font-bold tracking-tighter uppercase md:text-5xl">
            Our Construction Expertise
          </h2>
          <p className="font-default text-muted-foreground mx-auto max-w-2xl text-lg">Delivering structural excellence through licensed expertise and uncompromising industrial standards across the heart of <br />North Carolina.</p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {servicesData.map((service, i) => <div data-index={i} key={i} className="h-full">
              <Card className="group relative h-full overflow-hidden border-border bg-card py-0 backdrop-blur-none transition-all duration-500 hover:border-primary">
                {}
                <div className="absolute inset-0 z-0 flex items-start justify-center overflow-hidden opacity-5 transition-opacity duration-500 group-hover:opacity-20">
                  <pre className="animate-scroll-code font-mono text-xs text-primary">
                    {service.codeSnippet}
                    {"\n"}
                    {service.codeSnippet}
                  </pre>
                </div>

                {}
                <div className="absolute inset-0 z-0 bg-primary/0 transition-colors duration-500 group-hover:bg-primary/5"></div>

                <CardHeader className="relative z-10 px-8 pt-8 pb-4">
                  <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-none bg-secondary text-primary transition-all duration-500 group-hover:bg-primary group-hover:text-white group-hover:shadow-[0_0_30px_rgba(255,0,0,0.3)]">
                    <service.icon className="h-7 w-7" />
                  </div>
                  <CardTitle className="font-default text-2xl font-bold tracking-tighter uppercase text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="relative z-10 px-8 pb-8 pt-0">
                  <CardDescription className="font-default text-base leading-relaxed text-muted-foreground">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}